import React, { Component } from "react";
import lang from '../../lang';
import ListPannel from './list-pannel';
import Tooltip from 'rc-tooltip';
import { Link } from "react-router";
import List from "./list-pannel";
import Loading from "../../component/loading";
class HeadFollow extends Component {

	constructor(props) {
		super(props);
		this.state = {
			keyword: '',
			showSearchResult: false,
			counter: 0
		};
	}
    gitList= ()=>{
    	let counter = this.state.counter;
    	this.setState({
    		counter: counter+1
    	});
    }
	render() {
		
		let $pop = (
            <div key={this.state.counter} className="s-result s-result-pop ">
				<div className="s-result-scroller hostlist-lite" >
					<ListPannel   showFollowInfo="true" ref="list"/>
				</div>
            </div>
    	);
		
		return (
            <Tooltip getTooltipContainer={()=>this.refs.follow} overlay={$pop} placement="bottom" trigger={['hover']} overlayClassName="header-popover header-follow-popover">
				<div className="follow btn-head" ref="follow" >
					<div className="result-pop-hd" ref='follow' onMouseEnter={this.gitList}>
					 <Link to="/allhostlist/follow">{lang.template('关注')}</Link>
					</div>
				</div>
        	</Tooltip>
    	);

	}
}

export default HeadFollow;



// WEBPACK FOOTER //
// ./js/header/follow/index.js